<template>
    <div class="z-copyright">
        <span
            v-if="textBefore"
            class="z-copyright__text z-copyright__text--before">
            {{ textBefore }}
        </span>
        <span>&copy;&nbsp;</span>
        <span class="z-copyright__years">
            <span
                v-if="year"
                class="z-copyright__year-start">
                {{ this.year }}
            </span>
            <span v-html="hyphen"></span>
            <span
                v-if="isCurrentYear"
                class="z-copyright__year-current">
                {{ currentYear }}
            </span>
            <span
                v-if="textAfter"
                class="z-copyright__text z-copyright__text--after"
                v-html="textAfter"
            >
            </span>
        </span>
    </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
    textAfter: {
        type: String
    },
    textBefore: {
        type: String
    },
    isCurrentYear: {
        type: Boolean,
        default: false
    },
    year: {
        type: [String, Number]
    }
})

const currentYear = computed(() => {
    return new Date().getFullYear()
})

const hyphen = computed(() => {
    return props.year && props.isCurrentYear ? '&#8209;' : ''
})

defineExpose({
    props
})
</script>

<style lang="scss">
.z-copyright {
    display: inline;
    @include typo-level(S);
    line-height: 1;
    color: var(--color-white);

    @include breakpoint(mobile) {
        font-size: 14px;
    }

    &__text {
        &--before {
            margin-right: 0.3em;
        }

        &--after {
            margin-left: 0.3em;
        }
    }
}
</style>
